import React from "react";
import "../../stylesheet/components/people/PeopleCardSkeleton.scss";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

const PeopleCardSkeleton: React.FC = () => {
	return (
		<div className="people-skeleton-card-outer">
			<div className="people-skeleton-image-container">
        <Skeleton/>  
      </div>
			<div className="people-skeleton-card-content">
				<Skeleton width={70}/>
				<Skeleton width={100}/>
			</div>
		</div>
	);
};

export default PeopleCardSkeleton;
